import React from "react";
import ContentLoader from "react-content-loader";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  width: calc(100% + 20px);
  margin-left: -10px;
  margin-right: -10px;
  transform: translateY(-20px);
  @media screen and (min-width: 850px) {
    transform: translateY(0px);
  }
`;

const LoadingVenues: React.FC = props => (
  <Wrapper>
    <ContentLoader
      viewBox="0 0 1400 640"
      height={640}
      width={1400}
      speed={2}
      style={{ alignmentBaseline: "top" }}
    >
      <rect x="12" y="0" rx="8" ry="8" width="300" height="200" />
      <rect x="12" y="230" rx="0" ry="0" width="300" height="18" />
      <rect x="12" y="255" rx="0" ry="0" width="120" height="20" />

      <rect x="372" y="0" rx="8" ry="8" width="300" height="200" />
      <rect x="372" y="230" rx="0" ry="0" width="300" height="18" />
      <rect x="372" y="255" rx="0" ry="0" width="120" height="20" />

      <rect x="732" y="0" rx="8" ry="8" width="300" height="200" />
      <rect x="732" y="230" rx="0" ry="0" width="300" height="18" />
      <rect x="732" y="255" rx="0" ry="0" width="120" height="20" />

      <rect x="1092" y="0" rx="8" ry="8" width="300" height="200" />
      <rect x="1092" y="230" rx="0" ry="0" width="300" height="18" />
      <rect x="1092" y="255" rx="0" ry="0" width="120" height="20" />

      <rect x="12" y="340" rx="8" ry="8" width="300" height="200" />
      <rect x="12" y="570" rx="0" ry="0" width="300" height="18" />
      <rect x="12" y="595" rx="0" ry="0" width="120" height="20" />

      <rect x="372" y="340" rx="8" ry="8" width="300" height="200" />
      <rect x="372" y="570" rx="0" ry="0" width="300" height="18" />
      <rect x="372" y="595" rx="0" ry="0" width="120" height="20" />

      <rect x="732" y="340" rx="8" ry="8" width="300" height="200" />
      <rect x="732" y="570" rx="0" ry="0" width="300" height="18" />
      <rect x="732" y="595" rx="0" ry="0" width="120" height="20" />

      <rect x="1092" y="340" rx="8" ry="8" width="300" height="200" />
      <rect x="1092" y="570" rx="0" ry="0" width="300" height="18" />
      <rect x="1092" y="595" rx="0" ry="0" width="120" height="20" />
    </ContentLoader>
  </Wrapper>
);

export default LoadingVenues;
